import React from 'react';

const ModifySearchContext = React.createContext(null);

export default ModifySearchContext;
